import React, { useState, useRef, useEffect, Fragment } from "react";
import "./../components/Report.scss";
import { _hasPermission } from "../../../../../../shared/helpers/access";
import { _axiosCall } from "../../../../../../shared/helpers/apicalls";
import moment from "moment";
import { amenitiesList } from "../../../../../../shared/helpers/bp-utils.js";

import "../components/Report.scss";
import { Publisher } from "../../../../../../shared/pubsub/publisher.js";

import LocationIcon from "mdi-react/MapMarkerIcon";
import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  _replaceAbbreviations,
  _formatBed,
  _isEqual,
  _tranformTagsQuery,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  _activityFL,
  _getFeaturesArr,
  _chunkArray,
  _isCoop,
  _validUnitSources,
  propertyExportFL,
  propertyFL,
  _formatNum,
  _getBuildingPhotos,
  _getServiceLevel,
  _checkBuildingAltAdr,
  _calPercentage,
  _checkFieldForValue,
  _formatUnitNumber,
  buildingFL
} from "../../../../../../shared/helpers/utils";

import { userEditFieldsObj } from "../../../../../../shared/helpers/userEditFields.js";
import {
  generatePeriodNames,
  prepareResForAI,
  filterAIData,
  getCurrentPeriod,
  getPriorPeriod,
  getRangeEnd,
  getRangeStart,
  formatDate,
  validateNestedData,
  formatDateRange,
  percentageChange,
} from "../../../exportreport/utils";
import Header from "../components/Header.jsx";
import CustomSkeleton from "../../reports/components/Skeleton.jsx";


const apiURL = process.env.API_ROOT;


function calculateAverages(data, priceField, sqFtField) {
  if (!Array.isArray(data) || data.length === 0) {
  return { avgPrice: 0, avgPPSF: 0 };
  }

  let totalPrice = 0;
  let totalSqFt = 0;
  let validCount = 0;

  data.forEach((item) => {
  const price = parseFloat(item[priceField]);
  const sqFt = parseFloat(item[sqFtField]);

  if (!isNaN(price) && !isNaN(sqFt) && sqFt > 0) {
    totalPrice += price;
    totalSqFt += sqFt;
    validCount++;
  }
  });

  return {
  avgPrice: validCount > 0 ? totalPrice / validCount : 0,
  avgPPSF: totalSqFt > 0 ? totalPrice / totalSqFt : 0,
  };
}

let MIN_COUNT = 10;
const BlendedLayout = (props) => {
  const {
  fetchInProgress,
  setFetchInProgress,
  user,
  reportLoaded,
  setReportLoaded,
  reportData,
  setReportData,
  searchTags,
  summarizeGeographies,
  customDate,
  submit,
  setSubmit,
  color,
  compSettings,
  setAiResponse,
  AiResponse,
  setFetchAi,
  fetchAi,
  setAIInProgress,
  defaultLogo,
  logo,
  formValues
  } = props;
  const { tone, length, highlights, bedrooms, baths, customPrice, monthlyCC, monthlyTax, sq_ft } = compSettings.propertyDetails;

  useEffect(() => {
  console.log(reportData, fetchInProgress, submit, "mySubmit");

  if (!reportData && !fetchInProgress && submit) {
    const fetchData = async () => {
    await loadData();
    };

    fetchData();

    setSubmit(false);
  }
  }, [submit]);

  useEffect(() => {
  console.log(reportData, fetchAi);
  const fetchAIData = async () => {
    setFetchAi && setFetchAi(false);
    setAIInProgress(true);
    const aiResponse = await handleAIGenerate(reportData);
    console.log(aiResponse);
    setAiResponse && setAiResponse(aiResponse);
    setAIInProgress(false);
  };

  if (reportData && fetchAi) {
    fetchAIData();
  }
  }, [reportData, fetchAi]);

  //
  //
  // setFetchInProgress(false);
  // setReportLoaded(true);
  // setSubmit(false);

  const getLastMonthsQuery = (fieldName, months) => {
  const now = Math.floor(Date.now() / 1000); // Current timestamp in seconds
  const monthsAgo = now - months * 30 * 24 * 60 * 60; // Approximate number of months (30 days per month)

  return `${fieldName}:[${monthsAgo} TO ${now}]`;
  };

  const loadData = async () => {
  const addressQ =
    compSettings.selectedBuilding.alternate_addresses.join('" OR "');
  let q = `alternate_addresses:("${addressQ}") AND (zip:${
    compSettings.selectedBuilding.zip
  } OR borough:"${compSettings.selectedBuilding.borough.toLowerCase()}")`;

  const fq = ["deleted:false"];
  setFetchInProgress(true);
  let axiosData = {
    url: apiURL + "/query/we3-buildings?cache=60",
    method: "post",
    query: {
    q: q,
    wt: "json",
    fl: buildingFL,
    fq: fq,
    rows: 1,
    },
  };

  let res = await _axiosCall(axiosData)
    .then(async (res) => {
    let property = compSettings.propertyDetails && compSettings.propertyDetails.property ? compSettings.propertyDetails.property : false;
    let listing, buildingListing;
    if (res && res.docs && res.docs[0]) {
      console.log(property)
      if(property && property.last_listed_sale_key_all && !(property.last_listed_rent_status_all == 'active' && property.last_listed_sale_status_all !='active')){
      listing = await _getListingData(property.last_listed_sale_key_all);
      }else if(property && property.last_listed_rent_key_all){
      listing = await _getListingData(property.last_listed_rent_key_all);
      }else{
      buildingListing = await _getBuildingListingData(res.docs[0]);
      
      }
      let theReportData = {
      buildingRes: res.docs[0],
      compSettings,
      listing,
      buildingListing
      };
     
      setReportData(theReportData);
    }
    return res;
    })
    .catch((error) => {
    console.log("error: " + error);
    })
    .finally(() => {
    setFetchInProgress(false);
    setReportLoaded(true);
    setSubmit(false);
    setFetchAi && setFetchAi(true);
    });
  };
  
  const _getListingData = async (listingKey) => {
  const signedIn = true; //this.props.reduxState && this.props.reduxState.user.authenticated;		
  const q = `key:${listingKey.replace("REBNY-LISTING-", "*").replace("REBNY-VOW-", "REBNY-IDX-")}`;
  
  let axiosData = {
    url: apiURL + "/query/search-listings?cache=15",
    method: "post",
    query: {
    q: q,
    //fq: ["deleted:false"],
    sort: "solr_updated_date desc",
    wt: "json",
    rows: 10
    }
  };
  console.log(axiosData)
  let formattedData = await _axiosCall(axiosData)
    .then(res => {
    // console.log('Chart Data', res);
    if(res.docs && res.docs.length>0){					
      return res.docs[0];
    }else{
      return false;
    }
    
    })
    .catch(error => {
    console.log("error: " + error);
    });
  return formattedData;
  };
  
  const _getBuildingListingData = async (buildingRes) => {
    const signedIn = true; //this.props.reduxState && this.props.reduxState.user.authenticated;		
    const q = `(alternate_addresses:("${buildingRes.alternate_addresses.join('" OR "')}") AND zip:${buildingRes.zip})`;
  
    let axiosData = {
    url: apiURL + "/query/search-listings?cache=15",
    method: "post",
    query: {
      q: q,
      fl : ["description"],
      fq: ["deleted:false", "listing_type:sale"],
      sort: "sale_status asc, listing_date desc",
      wt: "json",
      rows: 5
    }
    };
  
    let formattedData = await _axiosCall(axiosData)
    .then(res => {
      // console.log('Chart Data', res);
      if(res.docs && res.docs.length>0){	
      let blgListing = res.docs[0];
      res.docs.forEach(l => {
        if(l.description && l.description.length > blgListing.description.length){
        blgListing = l;
        }
      })
          
      return blgListing;
      }else{
      return false;
      }
      
    })
    .catch(error => {
      console.log("error: " + error);
    });
    return formattedData;
  };

  const handleAIGenerate = async (theReportData) => {
  const { buildingRes, derivedData, compSettings, listing, buildingListing } =
    theReportData;
    
  let property = compSettings.propertyDetails && compSettings.propertyDetails.property ? compSettings.propertyDetails.property : false;
  const { selectedUnit } = compSettings;
  const buildingFieldMap = {
     "name" : { name: "Building Name", formatter : false } ,
     "display_full_street_address" :  { name: "Address", formatter : false } ,
     "neighborhood" :  { name: "Neighborhood", formatter : false } ,
     "architect" :  { name: "Architect", formatter : false } ,
     "total_floors" :  { name: "Total Floors", formatter : false } ,
     "year_built" :  { name: "Year Built", formatter : false } ,		 
     "developers" :  { name: "Developer", formatter : false } ,
     "interior_designers" :  { name: "Interior Designer", formatter : false } ,
    // "manager" :  { name: "Property Mananger", formatter : false } ,
     
   }
   const propertyFieldMap = {
    "floor" : { name: "Floor", formatter : false } ,
    "bedrooms" : { name: "Bedrooms", formatter : (val) => val == 0 ? "Studio" : val } ,
    "baths" :  { name: "Bathrooms", formatter : false } ,
    "sq_ft" :  { name: "Square Feet", Feet : _formatNumber } ,
    "exterior_sq_ft" :  { name: "Exterior Squre Feet", formatter : _formatNumber },
    "customPrice" :  { name: "Listing Price", formatter : _formatCurrency },
    "monthlyCC" :  { name: "Monthly Common Charges", formatter : _formatCurrency },
    "monthlyTax" :  { name: "Monthly Taxes", formatter : _formatCurrency }
    }
   // if(buildingRes["building_status"] == "sponsor"){		 
    //  buildingFieldMap["building_status"] = { name: "Building Sales Stage", formatter : (val => val + " Stage") };
   // }
   if(buildingRes["year_converted"] > buildingRes["year_built"]){		 
    buildingFieldMap["year_converted"] = { name: "Year Converted", formatter : false };
    }
    if(buildingRes['inventory_total'] && buildingRes['inventory_total'] > 1){
    buildingFieldMap["inventory_total"] = { name: "Total Units", formatter : false };
    }else if(buildingRes['total_units_residential'] && buildingRes['total_units_residential'] > 1){
    buildingFieldMap["total_units_residential"] = { name: "Total Units", formatter : false };
    }else if(buildingRes['total_units'] && buildingRes['total_units'] > 1){
    buildingFieldMap["total_units"] = { name: "Total Units", formatter : false };
    }
    
    
  
  
   
   let promptData = [];
   if(selectedUnit){
     promptData.push(`Unit Number=${selectedUnit}`);
   }
   if(compSettings.propertyDetails && compSettings.propertyDetails.bedrooms){
     Object.keys(compSettings.propertyDetails).map(key => {
        if(propertyFieldMap[key]){
        
        const val = Array.isArray(property[key]) && property[key][0] ? property[key][0] : property[key];			 
        if(val && _shouldShow(val)){
          promptData.push(`${propertyFieldMap[key].name}=${propertyFieldMap[key].formatter ? propertyFieldMap[key].formatter(val) : val}`);
        }
        }
      })
   }else if (property){
    Object.keys(property).map(key => {
       if(propertyFieldMap[key]){
       
       const val = Array.isArray(property[key]) && property[key][0] ? property[key][0] : property[key];			 
       if(val && _shouldShow(val)){
         promptData.push(`${propertyFieldMap[key].name}=${propertyFieldMap[key].formatter ? propertyFieldMap[key].formatter(val) : val}`);
       }
       }
     })
    }
   
   Object.keys(buildingRes).map(key => {
     if(buildingFieldMap[key]){
     
     const val = Array.isArray(buildingRes[key]) && buildingRes[key][0] ? buildingRes[key][0] : buildingRes[key];			 
     if(val && _shouldShow(val)){
       promptData.push(`${buildingFieldMap[key].name}=${buildingFieldMap[key].formatter ? buildingFieldMap[key].formatter(val) : val}`);
     }
     }
   })
   const compiledFeatureList = _getFeaturesArr('building', false, buildingRes);
    const highlightedAmenities = amenitiesList.filter(item => compiledFeatureList.some(el => item.values.includes(el))).map(el => el.name);
    
    promptData.push(`Building Amenities=${highlightedAmenities.join(", ")}`);
    
    if(highlights && highlights.length>0){
      promptData.push(`Key Unit Features=${highlights.join(", ")}`);
    }
    

   let prompt = `Write a real estate listing description in a ${tone ? tone : "neutral"} tone in ${length ? length : "400"} words.`;

   //prompt += " Don’t justify your answers. Don’t give information not mentioned in the Marketproof Data.";
   prompt += ` Don’t justify your answers.  Don't summarize. Include the address. Use facts.  Prioritize and use all the information provided in the Marketproof Data, especially Key Unit Features.  Return JSON format and store in {summary: "text"}`;
   
   if(buildingRes["building_status"] == "sponsor"){
    if (moment(buildingRes["building_effective_start"]).year() > 1970 || moment(buildingRes["first_closing_date"]).year() > 1970) {
     prompt += ` Add to the response: "Immediate closings."`;
       
     }
     if(buildingRes["inventory_pct_unsold"]){
     if(buildingRes["inventory_pct_unsold"] < 50 && buildingRes["inventory_pct_unsold"] > 15){
       prompt += ` Add to the response: "Over 50% sold."`;
     }else if(buildingRes["inventory_pct_unsold"] <= 15){
       prompt += ` Add to the response: "One of the last remaining units."`;
     }
     }
     if(buildingRes['offering_file_number'] && buildingRes['offering_file_number'] != ""){
     prompt += ` Append the following to the end: "The complete Offering Terms are in an Offering Plan available from Sponsor. File No. ${buildingRes['offering_file_number'].substring(0,2).toUpperCase()} ${buildingRes['offering_file_number'].substring(2,4)}-${buildingRes['offering_file_number'].substring(4)}."`;
     }
    }
  
   
   let systemContent = `You are a real estate expert, use the following Marketproof Data about a property.\n\n${promptData.join("\n")}`;
   
   if(listing && listing.description){
    systemContent += "\n\nThe following a description from a previous listing for this unit.  Extract unit features, finishes and building amenities from the following for text but always prioritize Marketproof Data when available.  Don’t justify your answers.";
    systemContent += "\n\n";
    systemContent += `"${listing.description}"`;
    }else if(buildingListing && buildingListing.description){
    systemContent += "\n\nThe following a listing description from the same building but not the same unit.  Extract only feature that would be in common for units in the building (ignore any that indicates renovation), finishes and building amenities from the following for text but always prioritize Marketproof Data when available.  Don’t justify your answers.";
     systemContent += "\n\n";
     systemContent += `"${buildingListing.description}"`;
    }
   

  const queryData = {
    messages: [
    {
      role: "system",
      content: systemContent,
    },
    { role: "user", content: prompt },
    ],
    model: "gpt-4o-mini",
    response_format: { type: "json_object" },
  };

  const axiosData = {
    url: apiURL + "/ai/chat",
    method: "post",
    query: queryData,
  };
  let aiResponse = {};
  try {
    const res = await _axiosCall(axiosData);
    console.log(res);

    if (
    res &&
    res.choices &&
    res.choices[0] &&
    res.choices[0].message &&
    res.choices[0].message.content
    ) {
    const result = res.choices[0].message.content;

    try {
      aiResponse = JSON.parse(result);
      console.log(aiResponse);
    } catch (e) {}
    }
  } catch (error) {
    console.log("Error generating summary:", error);
  }
  return aiResponse;
  };

  


  if (!reportData) return null;

  //const buildingRes = reportData.buildingRes.building[0];

  {
  console.log(reportData, "reportData");
  }
 

  const propertyDetails = reportData.compSettings.propertyDetails;
  
  const buildingRes = reportData.buildingRes;
 
  let floorPlan = propertyDetails.images && propertyDetails.images[3] && propertyDetails.images[3] != "" ? propertyDetails.images[3] : false;
  
  
  
  const compiledFeatureList = _getFeaturesArr("building", false, buildingRes);
  const highlightedAmenities = amenitiesList
  .filter((item) =>
    compiledFeatureList.some((el) => item.values.includes(el))
  )
  .map((el) => el.name);
const buildingNameOrAdr = buildingRes.name
  ? _capitalizeText(buildingRes.name)
  : buildingRes.display_full_street_address
  ? _capitalizeText(buildingRes.display_full_street_address)
  : _capitalizeText(buildingRes.full_street_address);  
  const address = `${buildingNameOrAdr}${propertyDetails && propertyDetails.property && propertyDetails.property.address_2_normalized ? ' - ' + propertyDetails.property.address_2_normalized.toUpperCase().replace("APT ", "") : ""}, ${_capitalizeText(buildingRes.neighborhood)}, ${_capitalizeText(buildingRes.borough)}`.toUpperCase();
  
  if(AiResponse && AiResponse.summary){
    let customData = Object.assign({}, propertyDetails, {summary: AiResponse.summary});
    Publisher.publish(`track-mp.aiUnitTask`, {user : user, building: buildingRes, property: propertyDetails.property ? propertyDetails.property : {}, customData: customData});
  }
  const {  dateOptions ,branding } = customDate;


  return (
  <div>
    <div className="header page-section listing-desc">
      <div className="export-header">
        <div className="coming__soon-contact-name">
          <div className="header-top">
           
            <div className="editable">Listing Description</div>
            {branding && branding && branding === "mylogo" && logo ? (
              <div className="brand-logo">
                <div>
                  <img
                    className="header-logo"
                    src={logo}
                    style={{ maxHeight: 100 }}
                  />
                </div>
              </div>
            ) : branding && branding && branding === "marketproof" ? (
              <div className="brand-logo">
                <div>
                  <img
                    src={defaultLogo}
                    style={{ maxHeight: 100 }}
                  />
                </div>
              </div>
            ) : null}
           
          </div>
          <div className="comp-address-top editable">{address}</div>       
        </div>
      </div>
    </div>
  
    <div className="report-container page-section newsletter-report-container listing-desc">
      <div className="main-content">
        <div className="text-content">
          <div className="">
            <div>
            {AiResponse && AiResponse.summary ? 
             <p
               className="editable copy-script"
               dangerouslySetInnerHTML={{
                 __html: AiResponse && AiResponse.summary
                   ? AiResponse.summary.replace(/\n/g, "<br />")
                   : ""
               }}
             >
             </p>:
             <p>
              <CustomSkeleton count={Math.floor(length / 10)} />
             </p>}
            </div>
  
           
          </div>
        </div>
        <div>
        {customDate && customDate.contact && customDate.contact === "show" ? (
        <div className={`contact editable ${propertyDetails.customPrice ? "has-price" : "no-price"}`}>
          <div className="contact-label editable">Contact</div>
          <div className="user-container">
          {user && user.avatar? <div
            className="avatar-img"
            style={{ backgroundImage: `url(${user.avatar})` }}
            alt="avatar"
          />:null}
          <div>
          <p className="name editable">
            {user.firstName} {user.lastName}
          </p>
          <div className="contact-title">
            {user.title && <span className="editable">{user.title}</span>}
            {user.company && (
              <span className="editable">
                {" | "}
                {user.company}
              </span>
            )}
          
            {user.agentLicenseNumber && (
              <span className="editable">
                {" "}
                {" | "}License #: {user.agentLicenseNumber}
              </span>
            )}
          </div>
          <div className="contact-info">
            {user.email && <span className="editable">{user.email}</span>}
            {user.primaryPhone && (
              <span className="editable">
                {" | "}
                {user.primaryPhone}
              </span>
            )}
          </div>
        
          </div>
          </div>
          </div>
        ) : null}
        
        
        </div>
      </div>
      
    </div>
  </div>

  );
};

export default BlendedLayout;